export const SITE_URL = "https://fanwork.kr";
export const SITE_NAME = "Fanwork";
/** Korean alternate name, used in structured data for Korean search engines (Naver, etc.) */
export const SITE_NAME_KO = "팬워크";

/** English (default locale) */
export const SITE_TITLE =
  "Fanwork | Global K-pop Fandom Platform for Fan Projects and Collaboration";
export const SITE_DESCRIPTION =
  "Fanwork is a global K-pop fandom platform where fans create projects, find collaborators, share fan activities, and connect through fandom communities.";

/** Korean (alternate locale) — factual translation of the English copy */
export const SITE_TITLE_KO =
  "팬워크(Fanwork) | 글로벌 K-pop 팬덤 플랫폼 · 팬 프로젝트와 협업";
export const SITE_DESCRIPTION_KO =
  "팬워크는 전 세계 K-pop 팬이 함께 프로젝트를 만들고, 협업할 동료를 찾고, 팬 활동을 공유하며 팬덤 커뮤니티로 연결되는 글로벌 팬덤 플랫폼입니다.";

export const SITE_KEYWORDS = [
  // English
  "k-pop fandom platform",
  "k-pop fan project",
  "fan collaboration app",
  "fan community",
  "k-pop community",
  "fanwork",
  // Korean
  "팬워크",
  "케이팝 팬덤 플랫폼",
  "케이팝 팬 프로젝트",
  "팬 협업 앱",
  "팬덤 커뮤니티",
  "케이팝 커뮤니티",
] as const;

/**
 * Bilingual FAQ for FAQPage structured data (SEO/AEO).
 * Korean entries help Korean answer engines and Naver surface accurate answers.
 */
export const FAQ_ENTRIES = [
  {
    question: "What is Fanwork?",
    answer:
      "Fanwork is a global K-pop fan collaboration platform where fans come together to create, share, and celebrate their favorite artists through collaborative projects.",
  },
  {
    question: "Is Fanwork free to use?",
    answer:
      "Yes, Fanwork is free to download and use. Join fans worldwide and start collaborating today.",
  },
  {
    question: "팬워크(Fanwork)는 어떤 서비스인가요?",
    answer:
      "팬워크는 전 세계 K-pop 팬이 함께 프로젝트를 만들고, 협업할 동료를 찾고, 팬 활동을 공유하며 좋아하는 아티스트를 함께 응원하는 글로벌 팬덤 협업 플랫폼입니다.",
  },
  {
    question: "팬워크는 무료인가요?",
    answer:
      "네, 팬워크는 무료로 다운로드하고 사용할 수 있습니다. 전 세계 팬들과 함께 지금 바로 협업을 시작해 보세요.",
  },
] as const;

/** 공식 문의 이메일 — Contact 페이지 히어로와 mailto 링크에 사용 */
export const CONTACT_EMAIL = "fanwork.global@gmail.com";

export const STORE_URLS = {
  ios: "https://apps.apple.com/kr/app/fanwork/id6502553917",
  android: "https://play.google.com/store/apps/details?id=kr.fanwork.nativeapp",
} as const;

export const SOCIAL_LINKS = {
  instagram: "https://instagram.com/fanwork_global",
  facebook: "https://www.facebook.com/people/FanWork-Kpop/61566942152409",
  youtube: "https://www.youtube.com/@fanwork_kr",
  x: "https://x.com/fanwork_fun",
} as const;

export const OG_IMAGE_PATH = "/assets/images/og_card.png";

/** Related official sites of the same company (used in Organization sameAs) */
export const RELATED_SITES = ["https://fanwork.co.kr"] as const;
